'use client'
import { useInitDatadog } from '@/services/logger/datadog.init'
import { useAllowActiveStylesInSafari } from '@/utils/useAllowActiveStylesInSafari'

// Separate component since we want to make it client-side and avoid re-rendering whole app if any internal state changes
export function AppInitTriggers() {
  useInitDatadog()
  useAllowActiveStylesInSafari()
  // TODO: GTM, track pageviews, track experiment impressions
  return null
}
